import React from "react";
import LegalShell from "@/components/LegalShell";

export default function Refunds() {
  return (
    <LegalShell title="Refund Policy" subtitle="Effective February 28, 2026 · Version 1.0">
      <Section title="7-day money-back guarantee">
        <p>
          Not sure WarPaint DFS is for you? For your <strong className="text-white">first
          subscription purchase</strong>, you may request a full refund within{" "}
          <strong className="text-white">seven (7) days</strong> of the initial charge — no
          questions asked. Email{" "}
          <a href="mailto:support@warpaintdfs.com" className="text-[#39FF14] underline">support@warpaintdfs.com</a>{" "}
          from the account's registered email address with the subject line{" "}
          <code className="bg-zinc-900 px-1.5 py-0.5 text-[#39FF14]">Refund Request</code> and we'll
          issue the refund within one business day.
        </p>
        <p className="mt-3">
          The 7-day guarantee applies to your <em>first</em> WarPaint DFS charge only. Weekly renewals
          are not covered by the no-questions-asked window; cancel before the renewal date to stop the next charge.
        </p>
      </Section>

      <Section title="Outage credits">
        <p>
          If the WarPaint DFS optimizer, live projections pipeline, or lineup CSV export is
          fully non-functional for <strong className="text-white">more than four (4) consecutive
          hours during a Sunday NFL slate</strong> (kickoff-lock ± 4h either side), all weekly
          subscribers active at the time of the outage will receive a full refund of that week's
          $99 charge, credited automatically to the payment method on file within seven (7)
          business days. Legacy season-pass holders receive a one-week extension of their
          subscription end date instead of a cash refund.
        </p>
        <p className="mt-3">
          Outage credits do NOT apply to:
        </p>
        <ul className="list-disc ml-6 mt-2 space-y-1">
          <li>Third-party outages (DraftKings, SportsGameOdds, Sleeper, Stripe, Resend).</li>
          <li>Individual features (e.g., the AI Attack Plan generator) while the core
              optimizer + projections pipeline remain operational.</li>
          <li>Scheduled maintenance announced at least 24h in advance.</li>
        </ul>
      </Section>

      <Section title="Weekly renewals">
        WarPaint DFS bills <strong className="text-white">$99 every 7 days</strong>. You can cancel at any
        time from Account → Subscription; access continues through the end of the week you already paid
        for and no further charges are made. Completed weeks are non-refundable. Legacy monthly and season
        subscriptions purchased before the weekly plan keep their original terms until they expire.
      </Section>

      <Section title="Chargebacks">
        Please email us BEFORE filing a chargeback with your bank. We will make every reasonable
        effort to resolve billing disputes within one business day. Filing a chargeback without
        first contacting support results in immediate account suspension until the dispute is
        resolved, and we reserve the right to charge a $25 dispute-processing fee for any
        chargeback ruled in our favor.
      </Section>

      <Section title="How to request a refund">
        <ol className="list-decimal ml-6 mt-2 space-y-1">
          <li>Email <a href="mailto:support@warpaintdfs.com" className="text-[#39FF14] underline">support@warpaintdfs.com</a> from your registered account email.</li>
          <li>Subject: <code className="bg-zinc-900 px-1.5 py-0.5 text-[#39FF14]">Refund Request</code></li>
          <li>Include the plan you purchased and (if outage-related) the approximate date and
              hours of the outage you experienced.</li>
          <li>We will acknowledge your request within one business day.</li>
        </ol>
      </Section>

      <Section title="Questions?">
        Email <a href="mailto:support@warpaintdfs.com" className="text-[#39FF14] underline">support@warpaintdfs.com</a> — a human reads every message.
      </Section>
    </LegalShell>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-bold text-white mb-2">{title}</h2>
      <div className="text-sm text-zinc-300 leading-relaxed">{children}</div>
    </div>
  );
}
